import { logException } from '../util/errorUtils'

export const HEARTLAND_SCRIPT_URL =
  'https://api.heartlandportico.com/SecureSubmit.v1/token/2.2/securesubmit.min.js'
const HEARTLAND_ERROR =
  'Your network is preventing us from loading a necessary resource. Please email us at support@foodsby.com.'

/*  This logic already exists in /redux/modules/checkout.js
    Reasons I created a new one:
        - We want to make such calls in the component level and avoid sagas
        - Don't want to import a service function out of a redux module
    Hopefully eventually we will kill the other one
*/
export const createSecureToken = ccProfile => {
  return new Promise((resolve, reject) => {
    if (!window.Heartland) {
      const ex = new Error(HEARTLAND_ERROR)
      logException(ex)
      throw ex
    }

    const { cvv, expMonth, expYear, firstName, lastName, number, saveCard, zipCode } = ccProfile

    const hps = new window.Heartland.HPS({
      cardCvv: cvv,
      cardExpMonth: expMonth.toString(),
      cardExpYear: expYear.toString(),
      cardNumber: number,
      error: resp => {
        logException(`Error processing Heartland token request: ${resp.error.message}`)
        reject(resp.error)
      },
      publicKey: process.env.REACT_APP_HEARTLAND_PUBLIC_KEY,
      success: resp => {
        /* eslint-disable camelcase */
        const { exp_month, exp_year, last_four, token_value } = resp

        const request = {
          expMonth: exp_month,
          expYear: exp_year,
          firstName,
          id: null,
          lastFour: last_four,
          lastName,
          saveCard,
          token: token_value,
          zipCode,
        }
        /* eslint-enable camelcase */
        resolve(request)
      },
    })
    hps.tokenize()
  })
}
